import { createStyles, makeStyles } from '@mui/styles';

const useMapSearchResultStyles = makeStyles(({ spacing }) => {
  return createStyles({
    connectedVehicleIcon: {
      marginBottom: spacing(),
    },
  });
});

export default useMapSearchResultStyles;
